import { call, put, all, takeEvery } from 'redux-saga/effects';
import API from './../../services/api';

import * as ACTION from './actions';

// worker Saga: will be fired on USER_FETCH_REQUESTED actions
function* fetch(action) {
  try {
    const response = yield call(API.call, 'json');
    const responseBody = yield call([response, 'json']);

    if (response.status >= 400) {
      yield put({ type: ACTION.FETCH_FAIL, error: responseBody });
    } else {
      yield put({ type: ACTION.FETCH_SUCCESS, payload: responseBody });
    }
  } catch (e) {
    yield put({ type: ACTION.FETCH_FAIL, error: e.message });
  }
}

function* sharePath(action) {
  const data = { graves: action.graves };
  try {
    const response = yield call(API.call, `paths/${action.hash}`, 'POST', data);
    // const responseBody = yield call([response, 'json']);
    if (response.status >= 400) {
      console.log('err');
    } else {
    }
  } catch (e) {
    console.log(e);
  }
}

function* fetchShared(action) {
  try {
    const response = yield call(API.call, `paths/${action.hash}`, 'GET');
    const responseBody = yield call([response, 'json']);

    if (response.status >= 400) {
      yield put({ type: ACTION.FETCH_SHARED_FAIL, error: responseBody });
    } else {
      yield put({ type: ACTION.FETCH_SHARED_SUCCESS, payload: responseBody });
    }
  } catch (e) {
    yield put({ type: ACTION.FETCH_SHARED_FAIL, error: e.message });
  }
}

function* mySaga() {
  yield all([
    takeEvery(ACTION.FETCH_REQUEST, fetch),
    takeEvery(ACTION.SHARE_PATH, sharePath),
    takeEvery(ACTION.FETCH_SHARED, fetchShared),
  ]);
}

export default mySaga;



// WEBPACK FOOTER //
// ./src/js/redux/sagas.js